import React, { useContext } from 'react';
import { List, Segment } from 'semantic-ui-react';
import { ViewSettingsContext } from '../cnr/contexts/ViewSettingsContext';
import { useTempSettings } from 'global/cnr/contexts/useHelpers/useTempSettings';

const GenericList = (props) => {

  const { formData } = props

  // viewSettingsContext 
  const viewSettingsContext = useContext(ViewSettingsContext);
  const { viewSettings_state } = viewSettingsContext ?? {}
  const { settings_temp } = viewSettings_state
  const { _global } = useTempSettings(settings_temp, true)
  const { uiElements } = _global ?? {}
  const { list } = uiElements ?? {}
  const _list = list ? { ...list } : {}
  let listProps = formData ? { ...formData } : _list

  const lister = () => {
    const items = []
    const count = 10
    for (var i = 1; i <= count; ++i) {
      items.push(<List.Item>{'Item ' + i}</List.Item>)
    }
    return <Segment basic inverted >
      <List inverted fluid {...listProps} >
        {items}
      </List>
    </Segment>
  }

  return lister()
}

export default GenericList